import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { components } from '@atlaskit/select';

/**
 * This creates a functional component that `react-select` will use to make the
 * SingleValue part of the different pickers.
 */
export const makeSingleValue = ({
  lang
}) => ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(components.SingleValue, _extends({}, props, {
    innerProps: {
      lang
    }
  }), children);
};